<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="-"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <a href="javascript:void(0)" @click="urlTo('noticeIndex')">通知公告</a> / <span>通知公告详情</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <div class="wraper" >
          <div class="details">
            <div >
              <h2 class="details_tit1" > {{detail.title}}</h2>
            </div>
            <p class="details_time">
              <span style="margin-right: 200px;"> 发布单位：{{detail.data_author}}</span><span> 发布日期：{{detail.time}}</span>
            </p>
            <div class="details_con">
              <div class="details_con_left" style="width: 97%;margin: 0 auto;">
                <dl>
                  <dd id="content" style="padding-top: 20px;word-break:break-all;"></dd>
                </dl>
                <!--                <p v-if="!this.$util.isEmpty(detail.attachIdList)">附件：<a href="javascript:void(0)" @click="downloadAttach">{{detail.title}}</a></p>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>
  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";

  export default {
    name: "NoticeDetail",
    components: {
      headers, fixedDiv, footers
    },
    data() {
      return {
        detail: {},
        detail_id: '',
        html_url: '',
      }
    },
    created() {
      this.detail_id = this.$route.query.detail_id;
      this.getDetail();
    },
    methods: {
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      },
      //获取政策文件详细
      getDetail() {
        this.$https.post("/api/pu/info/getNewsInfoContent_web.do", {dataId: this.detail_id}, response => {
          if (response.status === 200 && response.data.code === 200) {
            this.detail = response.data.data;
            // this.html_url = process.env.API_HOST + '/' + this.detail.data_html_url;
            // console.log(this.html_url)
            $('#content').html(response.data.data.content)
          }
        });
      },
      //下载附件
      downloadAttach() {
        // this.$https.downloadFile("/attach/download.do", {attachId: this.detail.attachIdList[0],}, response => {
        // });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/detail/NoticeDetail.vue